export enum LearningContentStatus {
    unpublished,
    published,
    inInspection
}
